<div class="m-2 container-fluid py-4">
  <div class="row justify-content-center">
    <div class="col-12 col-lg-10 col-xl-8">
      <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
        <p-card class="p-4">
          <ng-template #header>
            <div class="flex align-items-center justify-content-between">
              <h2 class="m-0 text-2xl font-bold">{{ pageTitle }}</h2>
            </div>
          </ng-template>
          <!-- Informações Básicas -->
          <div class="mb-4">
            <h3 class="text-lg font-semibold mb-3 text-primary">Informações Básicas</h3>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="field">
                <label for="name" class="block text-sm font-medium mb-2">
                  Nome <span class="text-red-500">*</span>
                </label>
                <input 
                  type="text" 
                  pInputText 
                  id="name"
                  formControlName="name"
                  placeholder="Ex: João Silva"
                  class="w-full"
                  [class.p-invalid]="userForm.get('name')?.invalid && userForm.get('name')?.touched" />
                <small 
                  *ngIf="getFieldError('name')" 
                  class="p-error block mt-1">
                  {{ getFieldError('name') }}
                </small>
              </div>
              
              <div class="field">
                <label for="email" class="block text-sm font-medium mb-2">
                  Email <span class="text-red-500">*</span>
                </label>
                <input 
                  type="email" 
                  pInputText 
                  id="email"
                  formControlName="email"
                  placeholder="Ex: joao@email.com"
                  class="w-full"
                  [class.p-invalid]="userForm.get('email')?.invalid && userForm.get('email')?.touched" />
                <small 
                  *ngIf="getFieldError('email')" 
                  class="p-error block mt-1">
                  {{ getFieldError('email') }}
                </small>
              </div>

              <div class="field">
                <label for="phone" class="block text-sm font-medium mb-2">
                  Telefone <span class="text-red-500">*</span>
                </label>
                <input 
                  type="tel" 
                  pInputText 
                  id="phone"
                  formControlName="phone"
                  placeholder="Ex: (11) 99999-9999"
                  class="w-full"
                  [class.p-invalid]="userForm.get('phone')?.invalid && userForm.get('phone')?.touched" />
                <small 
                  *ngIf="getFieldError('phone')" 
                  class="p-error block mt-1">
                  {{ getFieldError('phone') }}
                </small>
              </div>
              
              <div class="field">
                <label for="roleId" class="block text-sm font-medium mb-2">
                  Função <span class="text-red-500">*</span>
                </label>
                <select 
                  id="roleId"
                  formControlName="roleId"
                  class="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  [class.p-invalid]="userForm.get('roleId')?.invalid && userForm.get('roleId')?.touched">
                  <option [value]="null">Selecione uma função</option>
                  <option *ngFor="let role of roles" [value]="role.id">{{ role.description }}</option>
                </select>
                <small 
                  *ngIf="getFieldError('roleId')" 
                  class="p-error block mt-1">
                  {{ getFieldError('roleId') }}
                </small>
              </div>
            </div>
          </div>

          <p-divider />

          <!-- Informações Adicionais -->
          <div class="mb-4" *ngIf="isDriver">
            <h3 class="text-lg font-semibold mb-3 text-primary">Informações do Motorista</h3>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="field">
                <label for="cnh" class="block text-sm font-medium mb-2">
                  CNH <span class="text-red-500">*</span>
                </label>
                <input 
                  type="text" 
                  pInputText 
                  id="cnh"
                  formControlName="cnh"
                  placeholder="Ex: 12345678901"
                  class="w-full"
                  [class.p-invalid]="userForm.get('cnh')?.invalid && userForm.get('cnh')?.touched" />
                <small 
                  *ngIf="getFieldError('cnh')" 
                  class="p-error block mt-1">
                  {{ getFieldError('cnh') }}
                </small>
              </div>
            </div>
          </div>

          <!-- Mensagem de Erro -->
          <div *ngIf="errorMessage" class="mb-4">
            <p-message 
              severity="error" 
              [text]="errorMessage" 
              [closable]="false" />
          </div>
        </p-card>

        <!-- Botões de Ação -->
        <div class="bg-white rounded-lg shadow-1 p-4 mt-3">
          <div class="flex justify-content-end gap-2">
            <p-button 
              label="Cancelar" 
              severity="secondary" 
              (onClick)="onCancel()"
              [disabled]="isLoading"
              icon="pi pi-times" />
            
            <p-button 
              [label]="submitButtonText"
              severity="primary"
              type="submit"
              [disabled]="isLoading || userForm.invalid"
              [loading]="isLoading"
              icon="pi pi-check" />
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
